import { render, staticRenderFns } from "./CorChecklist.vue?vue&type=template&id=4b05931a&scoped=true"
import script from "./CorChecklist.vue?vue&type=script&lang=ts"
export * from "./CorChecklist.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=4b05931a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b05931a",
  null
  
)

export default component.exports